module.exports = __webpack_public_path__ + "img/ealom.cca278b9.svg";